const config = {
  routes: {
    label: 'Subsquadfaq',
    prefix: '/subsquadfaq',
  },
}

export default config
